import { API, graphqlOperation } from 'aws-amplify'
import { createLog } from '../graphql/mutations'
import moment from 'moment'
import Vue from 'vue'
import Confirm from '@/components/Confirm.vue'

export default {
  data() {
    return {
      myself: {},
      prefs: [
        '北海道', '青森県', '岩手県', '宮城県', '秋田県', '山形県', '福島県',
        '茨城県', '栃木県', '群馬県', '埼玉県', '千葉県', '東京都', '神奈川県',
        '新潟県', '富山県', '石川県', '福井県', '山梨県', '長野県', '岐阜県',
        '静岡県', '愛知県', '三重県', '滋賀県', '京都府', '大阪府', '兵庫県',
        '奈良県', '和歌山県', '鳥取県', '島根県', '岡山県', '広島県', '山口県',
        '徳島県', '香川県', '愛媛県', '高知県', '福岡県', '佐賀県', '長崎県',
        '熊本県', '大分県', '宮崎県', '鹿児島県', '沖縄県'
      ],
      payment: [
        'クレジットカード決済',
        'コンビニ決済',
        '銀行振込',
        '現金払い',
        '掛売り決済',
        '口座引き落とし',
        '手形',
      ],
    }
  },
  props: {
    rules: {
      type: Object,
      default: () => ({
        required: value => (!!value || value === 0) || '入力は必須です',
        empty: value => String(value).length > 0 || '入力は必須です',
        min8Char: value => (!value || String(value).length >= 8) || '8文字以上で指定してください',
        number: value => {
          const pattern = /^[+-]?[0-9]*[.]?[0-9]+$/
          return (!value || pattern.test(value)) || '数値を入力してください'
        },
        integer: value => {
          const pattern = /^(0|[-]?[1-9][0-9]*)$/
          return (!value || pattern.test(value)) || '整数を入力してください'
        },
        min0: value => (!value || value >= 0) || '0以上で指定してください',
        max100: value => (!value || value <= 100) || '100以下で指定してください',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return (!value || pattern.test(value)) || 'メールアドレスが正しくありません'
        },
        tel: value => {
          const pattern = /^0[0-9]{1,3}-[0-9]{2,4}-[0-9]{3,4}$/
          return (!value || pattern.test(value)) || '電話番号が正しくありません'
        },
        arrayEmpty: value => (!value || value.length > 0) || '選択は必須です',
        step15: value => {
          const dat = new Date()
          if (value) {
            const time = value.split(':')
            dat.setMinutes(time[1])
          }
          return (!value || dat.getMinutes() % 15 == 0) || '15分単位で指定してください'
        },
      }),
    },
  },
  computed: {

  },
  methods: {
    async $confirm(message) {
      return new Promise((resolve) => {
        const VM = Vue.extend(Confirm)
        new VM({
          parent: this,
          propsData: {
            message,
            okAction: () => resolve(true),
            cancelAction: () => resolve(false),
          },
        })
      }).catch((err) => {
        throw err
      })
    },
    myAlert(mess, type = 'error') {
      this.$store.dispatch('updateSnack', {
        visible: true,
        mess: mess,
        type: type,
      })
    },
    getMyself() {
      return this.$store.getters.myself
    },
    load(bool) {
      this.$store.dispatch('updateLoading', bool)
    },
    //日付フォーマット
    getDateTime(dateStr, format = 'YYYY-MM-DD HH:mm') {
      let date = moment(dateStr)
      return date.isValid() ? date.format(format) : '　'
    },
    //数値の桁埋め
    zeroPadding(num, len) {
      return (Array(len).join('0') + num).slice(-len)
    },
    //ユニークなファイル名を返す
    getUniqueName(fileName) {
      let reg = /(.*)(?:\.([^.]+$))/
      let st = 1000
      return new Date().getTime().toString(16) + Math.floor(st * Math.random()).toString(16) + '.' + fileName.match(reg)[2]
    },
    //カンマ区切りの数値を返す
    separate(num) {
      if (isNaN(num)) return '0'
      return String(num).replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
    },
    //時間の産出
    diffTime(start, end, numFlg = false, lestTimes = []) {

      if (!start || !end) return 0

      const a = moment(start, 'HH:mm')
      const b = moment(end, 'HH:mm')
      // eslint-disable-next-line no-unused-vars
      let sum = 0
      let rest = 0

      if (a > b) b.add(1, 'days')

      sum = b.diff(a, 'hours', true)

      for (const item of lestTimes) {
        let from = moment(item.start, 'HH:mm')
        let to = moment(item.end, 'HH:mm')

        //fromとtoが逆転している場合は日跨ぎ
        if (from > to) to.add(1, 'days')

        //範囲内かどうか
        if (from >= a && from <= b || to >= a && to <= b) {
          let s = from
          let e = to
          
          if (from < a) s = a
          if (to > b) e = b

          //休憩時間
          if (item.type == 1) {
            rest += e.diff(s, 'hours', true)
          }
        }
      }
      sum = sum - rest

      return numFlg ? sum : sum.toFixed(2)
    },
    //時間の産出
    diffSectionTime(start, end, lestTimes = []) {

      if (!start || !end) return 0

      const a = moment(start, 'HH:mm')
      const b = moment(end, 'HH:mm')
      // eslint-disable-next-line no-unused-vars
      let sum = 0
      let over = 0
      let midnight = 0
      let rest = 0

      if (a > b) b.add(1, 'days')

      sum = b.diff(a, 'hours', true)

      for (const item of lestTimes) {
        let from = moment(item.start, 'HH:mm')
        let to = moment(item.end, 'HH:mm')

        //fromとtoが逆転している場合は日跨ぎ
        if (from > to) to.add(1, 'days')

        //範囲内かどうか
        if (from >= a && from <= b || to >= a && to <= b || from <= a && to >= b) {
          let s = from
          let e = to
          
          if (from < a) s = a
          if (to > b) e = b

          //休憩時間
          switch (item.type) {
            case 1:
              rest += e.diff(s, 'hours', true)
              break
            case 2:
              over += e.diff(s, 'hours', true)
              break
            case 3:
              midnight += e.diff(s, 'hours', true)
              break
          }
        }
      }
      sum = sum - rest - over - midnight

      return { sum: sum, over: over, midnight: midnight }
    },
    //時間の表示
    unixToTime(time) {
      return moment(time, 'X').format('HH:mm')
    },
    //非同期でblobを読み込んでテキストデータを返す
    readBlogToTextAsync(blob) {
      return new Promise((resolve, reject) => {
        let reader = new FileReader()
        reader.onload = () => {
          resolve(reader.result)
        }
        reader.onerror = reject
        reader.readAsText(blob)
      })
    },
    //blob to dataURI
    readBlogToURIAsync(blob) {
      return new Promise((resolve, reject) => {
        let reader = new FileReader()
        reader.onload = () => {
          resolve(reader.result)
        }
        reader.onerror = reject
        reader.readAsDataURL(blob)
      })
    },
    //選択ダイアログを開く
    openSelected(ref, add = false) {
      let container = Array.isArray(this.$refs[ref]) ? this.$refs[ref][0] : this.$refs[ref]
      this.$store.dispatch('updateSelected', {
        visible: true,
        items: container.items,
        ref: container,
        add: add,
      })
    },
    //選択ダイアログを閉じる
    closeSelected(value) {
      if (value) {
        this.$store.getters.selected.ref.setValue(value)
        
      }
      this.$store.dispatch('updateSelected', {
        visible: false,
        items: [],
        ref: null,
        add: false,
      })
    },
    //lightbox風のプレビューを表示
    lightboxFunc(url) {
      const origin = url.split('?')[0]
      if (this.getExt(origin)) {
        //画像はポップアップで表示
        this.$store.dispatch('updatePreview', {
          visible: true,
          src: url,
        })

      } else {
        //その他は別タブで表示
        window.open(url, '_blank')
      }
    },
    getExt(fileName) {
      const imageExt = ['jpg', 'jpeg', 'png', 'gif']

      let pos = fileName.lastIndexOf('.')
      if (pos === -1) return false

      let ext = fileName.slice(pos + 1)
      pos = ext.indexOf('?')

      if (pos !== -1) ext = ext.slice(0, pos)

      return imageExt.find(e => e === ext.toLowerCase()) ? true : false
    },
    //権限チェック
    isBlockAllowed(children) {
      for (const scene of children) {
        if (this.isAllowed(scene.name)) return true
      }
      return false
    },
    //権限チェック
    isAllowed(name) {
      const roles = this.$store.getters.roles
      if (this.getMyself() && roles.length > 0) {
        for (const role of this.getMyself().role) {
          const item = roles.find(e => e.name == role)
          const f = item.functions.find(e => e.name == name)
          if (f && f.enabled) return true
        }
      }
      return false
    },
    //CSV出力
    outputCsv(rows, fileName) {
      let csv = '\ufeff'

      csv += rows.join('\n')
      let blob = new Blob([csv], { type: 'text/csv' })
      //ダウンロード
      let link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = fileName + '.csv'
      link.click()
      link.remove()
    },
    //ログ出力
    async log(data) {
      try {
        await API.graphql(graphqlOperation(createLog, {
          input: {
            userID: this.getMyself().id,
            type: data.type,
            text: data.text,
            createdAt: moment().format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
            ttl: moment().add(30, 'days').unix(),
          }
        }))
      } catch (e) {
        this.myAlert(e)
      }
    },
  }
}
